import React from "react";
import CryptoJS from "crypto-js";
import { connect } from "react-redux";
import Button from "components/CustomButtons/Button.jsx";
import "assets/scss/responsive.css";
import "./customstyle.css";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import ChartistGraph from "react-chartist";

import Timeline from "@material-ui/icons/Timeline";
import withStyles from "@material-ui/core/styles/withStyles";

import chartsStyle from "assets/jss/material-dashboard-pro-react/views/chartsStyle.jsx";
import API from "@aws-amplify/api";
import Slider from "@material-ui/lab/Slider";
import { Chart } from "react-google-charts";

let apiName = process.env.REACT_APP_AMPLIFY_API;

// core components
class Summary extends React.Component {
  constructor(props) {
    super(props);
    //this.props.dispatch({ type: "SHOW_TABS", payload: "no" });
    // this.apiFetch();
  }

  componentDidMount() {
    let count = 0;
    this.setState({ updateSummary: true });
    if (this.props.editMode != undefined) {
      setTimeout(() => {
        this.apiFetch("where");
      }, 1000);
    } else {
      this.apiFetch("no_where");
    }
  }

  state = {
    dataAge: [],
    dataIncome: [],
    dataLifeDrivers: [],
    dataLifeDriversDup: [],
    excludedCount: 0,
    showSummary: true,
    updateSummary: false,
    query_count: "",
    full_count: "",
    address_count: "",
    total_audience_email_count: "",
    total_audience_email_pre: "",
    total_audience_email_eclub: "",
    total_non_mkt: "",
    total_mkt: "",
    non_eclub_emails: "",
    non_preclub_emails: "",
    non_email_custs: "",
    non_direct_mail: "",
    email_count: "",
    remainder: 0,
    tempdataLifeDrivers: [],
  };

  getSegmentsData(where) {
    let selectedRule = "";
    let selectedOptionValue = "";
    let selectedResult = [];
    let groupLeveltoggle = this.props.cust_groupLeveltoggleSegment;
    let ruleLeveltoggle = this.props.cust_ruleLeveltoggleSegment;
    let count = 0;
    let sqlAndOrOperator = "";
    this.props.cust_tillSqlSelectionArrSegment.map((resultData, index) => {
      let segment = "";
      if (this.props.cust_segmentName[index] != undefined) {
        segment = this.props.cust_segmentName[index];
      }
      selectedRule += `WHEN `;
      resultData.map((options, key) => {
        let length = options.length;
        if (options[length - 2].value.includes("+++")) {
          options[length - 2].value = options[length - 2].value.split("+++")[0];
        }
        if (
          options[length - 1].value === "BETWEEN" ||
          options[length - 1].value === "NOT BETWEEN"
        ) {
          selectedRule += "(";
        }

        if (
          options[length - 1].value === "cardinality(array_intersect(" ||
          options[length - 1].value === "cardinality(array_except("
        ) {
          selectedRule +=
            "(" +
            options[length - 1].value +
            options[length - 2].value +
            ", array";
        } else {
          selectedRule +=
            "(" + options[length - 2].value + " " + options[length - 1].value;
        }

        let data = this.props.cust_afterSqlSelectionArrSegment[index][key];
        if (data.length > 0) {
          data.map((result, resultKey) => {
            count = count + 1;
            sqlAndOrOperator = "";
            if (
              options[length - 1].value == "IN" ||
              options[length - 1].value == "NOT IN"
            ) {
              if (resultKey == 0) {
                selectedRule += `(`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                } else {
                  selectedRule += ` ${result.value}, `;
                }
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                selectedRule += `))`;
                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                } else {
                  selectedRule += ` ${result.value}, `;
                }
              }
            } else if (
              options[length - 1].value == "cardinality(array_intersect("
            ) {
              if (resultKey == 0) {
                selectedRule += `[`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                let aggarray = [];
                selectedRule += ` '${result.value}', `;
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                selectedRule += `])) > 0 AND ${JSON.parse(
                  CryptoJS.AES.decrypt(
                    localStorage.getItem("globalFilter"),
                    process.env.REACT_APP_PASS
                  ).toString(CryptoJS.enc.Utf8)
                )})`;

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                selectedRule += ` '${result.value}', `;
              }
            } else if (
              options[length - 1].value == "cardinality(array_except("
            ) {
              if (resultKey == 0) {
                selectedRule += `[`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                let aggarray = [];
                selectedRule += ` '${result.value}', `;
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                selectedRule += `])) > 0 AND ${JSON.parse(
                  CryptoJS.AES.decrypt(
                    localStorage.getItem("globalFilter"),
                    process.env.REACT_APP_PASS
                  ).toString(CryptoJS.enc.Utf8)
                )})`;

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                selectedRule += ` '${result.value}', `;
              }
            } else if (options[length - 1].value == "= ") {
              selectedRule += ` ${result.value} AND ${JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("globalFilter"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              )})`;
            } else {
              let num = result.value;
              if (
                options[length - 1].value === "BETWEEN" ||
                options[length - 1].value === "NOT BETWEEN"
              ) {
                selectedRule += ` ${result.value}) AND ${JSON.parse(
                  CryptoJS.AES.decrypt(
                    localStorage.getItem("globalFilter"),
                    process.env.REACT_APP_PASS
                  ).toString(CryptoJS.enc.Utf8)
                )}),`;
              } else if (typeof num == "string") {
                selectedRule += ` '${result.value}'), `;
              } else {
                selectedRule += ` ${result.value}), `;
              }
              selectedRule = selectedRule.replace(/,(\s+)?$/, "");
              if (
                ruleLeveltoggle.length > 0 &&
                key !== resultData.length - 1 &&
                ruleLeveltoggle[index] !== undefined &&
                ruleLeveltoggle[index][key] !== undefined
              ) {
                sqlAndOrOperator = ruleLeveltoggle[index][key];
                selectedRule += ` ${sqlAndOrOperator} `;
              }
            }
          });
        }
      });
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
      selectedRule += ` THEN `;
      selectedRule += ` '${segment}' `;
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
    });
    if (selectedRule != "") {
      let fQS = "";
      if (where == "") {
        fQS =
          "select CASE " +
          selectedRule +
          " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".cust_analytic ca LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("globalFilter"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          " GROUP BY 1";
        //fQS = "select case " + selectedRule + " else 'remainder' end segment, count_if(ca.eclub) eclub_count, count_if(ca.preclub) preclub_count, count_if(if(ca.eclub or ca.preclub,true,false)) email_count, count(distinct(ci.cust_id)) dm_count from " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + " .cust_analytic ca left join " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + " .client_intellibase ci on ca.cust_id = ci.cust_id where " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('globalFilter'),'secretpass').toString(CryptoJS.enc.Utf8)) + " and " + where + "group by 1";
        /*fQS =
          "SELECT segment, count(*) as count from (SELECT CASE " +
          selectedRule +
          "ELSE 'Remainder' END AS segment FROM " + process.env.REACT_APP_ATHENA_TABLE + " WHERE cac_addr_state='IN' ) GROUP BY segment";
          */
      } else {
        if (where.includes("li.")) {
          fQS =
            "select CASE " +
            selectedRule +
            " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("custDb"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ) +
            ".cust_analytic ca LEFT JOIN " +
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("custDb"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ) +
            ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("custDb"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ) +
            ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("custDb"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ) +
            ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("custDb"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ) +
            ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("custDb"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ) +
            ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("custDb"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ).split("_")[0] +
            "_raw.lists_preclub li ON li.cust_id = ca.cust_id WHERE " +
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("globalFilter"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ) +
            " AND " +
            where +
            " GROUP BY 1";
        } else {
          fQS =
            "select CASE " +
            selectedRule +
            " ELSE 'Remainder' END segment, count(distinct(ca.cust_id)) count FROM " +
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("custDb"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ) +
            ".cust_analytic ca LEFT JOIN " +
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("custDb"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ) +
            ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("custDb"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ) +
            ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("custDb"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ) +
            ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("custDb"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ) +
            ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("custDb"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ) +
            ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("globalFilter"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ) +
            " AND " +
            where +
            " GROUP BY 1";
        } //fQS = "select case " + selectedRule + "else 'remainder' end segment, count_if(ca.eclub) eclub_count, count_if(ca.preclub) preclub_count, count_if(if(ca.eclub or ca.preclub,true,false)) email_count, count(distinct(ci.cust_id)) dm_count from " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + " .cust_analytic ca left join " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + " .client_intellibase ci on ca.cust_id = ci.cust_id where " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('globalFilter'),'secretpass').toString(CryptoJS.enc.Utf8)) + "group by 1";
        /*fQS =
          "SELECT segment, count(*) as count from (SELECT CASE " +
          selectedRule +
          "ELSE 'Remainder' END AS segment FROM " + process.env.REACT_APP_ATHENA_TABLE + " WHERE " +
          where +
          ") GROUP BY segment";*/
      }
      let myInitCount = {
        headers: {},
        body: {
          sql: fQS,
          isCustSegment: true,
          custDb: JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ),
        },
      };
      if (
        this.props.cust_summaryDetails["segment_details"]["condition"] === "" ||
        this.props.cust_summaryDetails["segment_details"]["condition"] !== fQS
      ) {
        API.post(apiName, "/counts", myInitCount)
          .then((response) => {
            this.props.dispatch({
              type: "CUST_UPDATE_SUMMARY_DETAILS",
              segmentPayload: fQS,
              segmentValue: response,
            });
            this.props.dispatch({ type: "CUST_Add" });
            this.prepareSegmentsData(response);
          })
          .catch((error) => {
            this.setState({ remainder: 0 });
          });
      } else {
        if (
          this.props.cust_summaryDetails["segment_details"]["value"] !==
          undefined
        ) {
          this.prepareSegmentsData(
            this.props.cust_summaryDetails["segment_details"]["value"]
          );
        }
      }
    } else {
      this.setState({ remainder: 0 });
    }
  }

  prepareSegmentsData(response) {
    let res = response["final_result"]["Items"];
    if (res != undefined) {
      this.props.dispatch({
        type: "CUST_UPDATE_QUERY_COUNT_SEGMENT",
        segmentData: response["final_result"]["Items"],
      });
      this.props.dispatch({ type: "CUST_Add" });
      for (let data in res) {
        if (res[data].segment === "Remainder") {
          this.setState({ remainder: res[data].count });
        }
      }
    } else {
      this.setState({ remainder: 0 });
    }
  }

  getWhereCondition() {
    let self = this;
    let groupLeveltoggle = self.props.cust_groupLeveltoggle;
    let ruleLeveltoggle = self.props.cust_ruleLeveltoggle;
    let selectedRule = "";
    let selectedOptionValue = "";
    let selectedResult = [];
    let count = 0;
    let sqlAndOrOperator = "";
    self.props.cust_tillSqlSelectionArr.map((resultData, index) => {
      selectedRule += `(`;
      resultData.map((options, key) => {
        let length = options.length;
        if (options[length - 2].value.includes("+++")) {
          options[length - 2].value = options[length - 2].value.split("+++")[0];
        }
        if (
          options[length - 1].value === "BETWEEN" ||
          options[length - 1].value === "NOT BETWEEN"
        ) {
          selectedRule += "(";
        }
        if (
          options[length - 1].value === "cardinality(array_intersect(" ||
          options[length - 1].value === "cardinality(array_except("
        ) {
          selectedRule +=
            "(" +
            options[length - 1].value +
            options[length - 2].value +
            ", array";
        } else {
          selectedRule +=
            "(" + options[length - 2].value + " " + options[length - 1].value;
        }
        let data = self.props.cust_afterSqlSelectionArr[index][key];
        if (data.length > 0) {
          data.map((result, resultKey) => {
            count = count + 1;
            sqlAndOrOperator = "";
            if (
              options[length - 1].value == "IN" ||
              options[length - 1].value == "NOT IN"
            ) {
              if (resultKey == 0) {
                selectedRule += `(`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                } else {
                  selectedRule += ` ${result.value}, `;
                }
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                selectedRule += `) AND ${JSON.parse(
                  CryptoJS.AES.decrypt(
                    localStorage.getItem("globalFilter"),
                    process.env.REACT_APP_PASS
                  ).toString(CryptoJS.enc.Utf8)
                )} )`;

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                } else {
                  selectedRule += ` ${result.value}, `;
                }
              }
            } else if (
              options[length - 1].value == "cardinality(array_intersect("
            ) {
              if (resultKey == 0) {
                selectedRule += `[`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                let aggarray = [];
                selectedRule += ` '${result.value}', `;
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                selectedRule += `])) > 0 AND ${JSON.parse(
                  CryptoJS.AES.decrypt(
                    localStorage.getItem("globalFilter"),
                    process.env.REACT_APP_PASS
                  ).toString(CryptoJS.enc.Utf8)
                )})`;

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                selectedRule += ` '${result.value}', `;
              }
            } else if (
              options[length - 1].value == "cardinality(array_except("
            ) {
              if (resultKey == 0) {
                selectedRule += `[`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                let aggarray = [];
                selectedRule += ` '${result.value}', `;
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                selectedRule += `])) > 0 AND ${JSON.parse(
                  CryptoJS.AES.decrypt(
                    localStorage.getItem("globalFilter"),
                    process.env.REACT_APP_PASS
                  ).toString(CryptoJS.enc.Utf8)
                )})`;

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                selectedRule += ` '${result.value}', `;
              }
            } else if (options[length - 1].value == "= ") {
              selectedRule += ` ${result.value} AND ${JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("globalFilter"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              )})`;
            } else {
              let num = result.value;
              if (
                options[length - 1].value === "BETWEEN" ||
                options[length - 1].value === "NOT BETWEEN"
              ) {
                selectedRule += ` ${result.value}) AND ${JSON.parse(
                  CryptoJS.AES.decrypt(
                    localStorage.getItem("globalFilter"),
                    process.env.REACT_APP_PASS
                  ).toString(CryptoJS.enc.Utf8)
                )}),`;
              } else if (typeof num == "string") {
                selectedRule += ` '${result.value}' AND ${JSON.parse(
                  CryptoJS.AES.decrypt(
                    localStorage.getItem("globalFilter"),
                    process.env.REACT_APP_PASS
                  ).toString(CryptoJS.enc.Utf8)
                )}),`;
              } else {
                selectedRule += ` ${result.value} AND ${JSON.parse(
                  CryptoJS.AES.decrypt(
                    localStorage.getItem("globalFilter"),
                    process.env.REACT_APP_PASS
                  ).toString(CryptoJS.enc.Utf8)
                )}),`;
              }
              selectedRule = selectedRule.replace(/,(\s+)?$/, "");
              if (
                ruleLeveltoggle.length > 0 &&
                key !== resultData.length - 1 &&
                ruleLeveltoggle[index] !== undefined &&
                ruleLeveltoggle[index][key] !== undefined
              ) {
                sqlAndOrOperator = ruleLeveltoggle[index][key];
                selectedRule += ` ${sqlAndOrOperator} `;
              }
            }
          });
        }
      });
      selectedRule += `)`;
      sqlAndOrOperator = "";
      if (
        groupLeveltoggle.length > 0 &&
        self.props.cust_tillSqlSelectionArr.length - 1 != index &&
        groupLeveltoggle[0] != undefined &&
        groupLeveltoggle[0][index] != undefined
      ) {
        sqlAndOrOperator = groupLeveltoggle[0][index];
        selectedRule += ` ${sqlAndOrOperator} `;
      }
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
      // self.setState({ query: selectedRule });
    });
    return selectedRule;
  }

  fetchChartsData(whereCondition) {
    let myInitCount = {
      headers: {},
      body: {
        isCustSihlouttes: true,
        where: whereCondition,
        geoConceptCheck: JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("globalFilter"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ),
        custDb: JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ),
      },
    };
    whereCondition = whereCondition === "" ? "-" : whereCondition;
    API.post(apiName, "/counts", myInitCount)
      .then((response) => {
        let backResp = JSON.parse(
          response["final_result"]["Items"][0]["results"]
        );
        //this.state.totalUniverse = backResp['total_universe']['total_universe'];
        this.props.dispatch({
          type: "CUST_UPDATE_SUMMARY_DETAILS",
          chartsPayload: whereCondition,
          chartsValue: backResp,
        });
        this.props.dispatch({ type: "CUST_Add" });
        this.prepareIncomeAgeDrivers(backResp);
      })
      .catch((error) => {
        this.setState({ showSummary: false });
        //this.props.dispatch({ type: "SHOW_TABS", payload: "yes" });
      });
  }

  fetchQueryData(fQS) {
    setTimeout(() => {
      let myInitCount = {
        headers: {},
        body: {
          sql: fQS,
          isCustFilter: true,
          custDb: JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ),
        },
      };
      let query_count = "";
      let full_count = "";
      let address_count = "";
      let email_count = "";
      API.post(apiName, "/counts", myInitCount)
        .then((response) => {
          this.props.dispatch({
            type: "CUST_UPDATE_SUMMARY_DETAILS",
            queryPayload: fQS,
            queryValue: response,
          });
          this.props.dispatch({ type: "CUST_Add" });
          this.prepareQueryData(response);
        })
        .catch((error) => {
          this.setState({ email_count: "" });
          this.setState({ full_count: "" });
          this.setState({ address_count: "" });
          this.setState({ total_audience_email_count: "" });
          this.setState({ total_audience_email_pre: "" });
          this.setState({ total_audience_email_eclub: "" });
          this.setState({ total_non_mkt: "" });
          this.setState({ total_mkt: "" });
          this.setState({ non_eclub_emails: "" });
          this.setState({ non_preclub_emails: "" });
          this.setState({ non_email_custs: "" });
          this.setState({ non_direct_mail: "" });
          this.setState({ email_count: "" });
          this.setState({ showSummary: false });
          if (this.props.editMode != undefined) {
            this.props.dispatch({
              type: "CUST_UPDATE_QUERY_COUNT",
              query_count: " ",
              full_count: " ",
              address_count: " ",
              email_count: " ",
              preview: [],
              total_audience_email_count: " ",
              total_audience_email_pre: " ",
              total_audience_email_eclub: " ",
              total_non_mkt: " ",
              total_mkt: " ",
              non_eclub_emails: " ",
              non_preclub_emails: " ",
              non_email_custs: " ",
              non_direct_mail: " ",
            });
          } else {
            this.props.dispatch({
              type: "CUST_CUSTOM_QUERY_COUNT",
              query_count: "",
              full_count: "",
              address_count: "",
              total_audience_email_count: "",
              total_audience_email_pre: "",
              total_audience_email_eclub: "",
              total_non_mkt: "",
              total_mkt: "",
              non_eclub_emails: "",
              non_preclub_emails: "",
              non_email_custs: "",
              non_direct_mail: "",
              email_count: "",
              preview: [],
            });
          }
        });
    }, 1000);
  }

  prepareQueryData(response) {
    let query_count = "";
    let full_count = "";
    let address_count = "";
    let email_count = "";
    let total_audience_email_count = "";
    let total_audience_email_pre = "";
    let total_audience_email_eclub = "";
    let total_non_mkt = "";
    let total_mkt = "";
    let non_eclub_emails = "";
    let non_preclub_emails = "";
    let non_email_custs = "";
    let non_direct_mail = "";
    if (
      response["final_result"] !== undefined &&
      response["final_result"]["Items"] !== undefined &&
      response["final_result"]["Items"].length > 0 &&
      response["final_result"]["Items"][0]["_col0"] !== undefined
    ) {
      query_count = response["final_result"]["Items"][0]["_col0"];
    }
    if (
      response["full_result"] !== undefined &&
      response["full_result"]["Items"] !== undefined &&
      response["full_result"]["Items"].length > 0 &&
      response["full_result"]["Items"][0]["_col0"] !== undefined
    ) {
      full_count = response["full_result"]["Items"][0]["_col0"];
    }
    if (
      response["address_result"] !== undefined &&
      response["address_result"]["Items"] !== undefined &&
      response["address_result"]["Items"].length > 0 &&
      response["address_result"]["Items"][0]["_col0"] !== undefined
    ) {
      address_count = response["address_result"]["Items"][0]["_col0"];
      // this.setState({address_count: response["address_result"]["Items"][0]["_col0"]})
    }
    if (
      response["email_result"] !== undefined &&
      response["email_result"]["Items"] !== undefined &&
      response["email_result"]["Items"].length > 0 &&
      response["email_result"]["Items"][0]["_col0"] !== undefined
    ) {
      email_count = response["email_result"]["Items"][0]["_col0"];
      // this.setState({email_count: response["email_count"]["Items"][0]["_col0"]})
    }
    if (
      response["total_audience"] !== undefined &&
      response["total_audience"]["Items"] !== undefined &&
      response["total_audience"]["Items"].length > 0 &&
      response["total_audience"]["Items"][0]["_col0"] !== undefined
    ) {
      total_audience_email_count =
        response["total_audience"]["Items"][0]["_col0"];
      // this.setState({email_count: response["email_count"]["Items"][0]["_col0"]})
    }
    if (
      response["total_audience_pre"] !== undefined &&
      response["total_audience_pre"]["Items"] !== undefined &&
      response["total_audience_pre"]["Items"].length > 0 &&
      response["total_audience_pre"]["Items"][0]["_col0"] !== undefined
    ) {
      total_audience_email_pre =
        response["total_audience_pre"]["Items"][0]["_col0"];
    }
    if (
      response["total_audience_eclub"] !== undefined &&
      response["total_audience_eclub"]["Items"] !== undefined &&
      response["total_audience_eclub"]["Items"].length > 0 &&
      response["total_audience_eclub"]["Items"][0]["_col0"] !== undefined
    ) {
      total_audience_email_eclub =
        response["total_audience_eclub"]["Items"][0]["_col0"];
    }
    if (
      response["total_non_mkt"] !== undefined &&
      response["total_non_mkt"]["Items"] !== undefined &&
      response["total_non_mkt"]["Items"].length > 0 &&
      response["total_non_mkt"]["Items"][0]["_col0"] !== undefined
    ) {
      total_non_mkt = response["total_non_mkt"]["Items"][0]["_col0"];
    }
    if (
      response["total_mkt"] !== undefined &&
      response["total_mkt"]["Items"] !== undefined &&
      response["total_mkt"]["Items"].length > 0 &&
      response["total_mkt"]["Items"][0]["_col0"] !== undefined
    ) {
      total_mkt = response["total_mkt"]["Items"][0]["_col0"];
    }
    if (
      response["non_eclub_emails"] !== undefined &&
      response["non_eclub_emails"]["Items"] !== undefined &&
      response["non_eclub_emails"]["Items"].length > 0 &&
      response["non_eclub_emails"]["Items"][0]["_col0"] !== undefined
    ) {
      non_eclub_emails = response["non_eclub_emails"]["Items"][0]["_col0"];
    }

    if (
      response["non_preclub_emails"] !== undefined &&
      response["non_preclub_emails"]["Items"] !== undefined &&
      response["non_preclub_emails"]["Items"].length > 0 &&
      response["non_preclub_emails"]["Items"][0]["_col0"] !== undefined
    ) {
      non_preclub_emails = response["non_preclub_emails"]["Items"][0]["_col0"];
    }

    if (
      response["non_email_custs"] !== undefined &&
      response["non_email_custs"]["Items"] !== undefined &&
      response["non_email_custs"]["Items"].length > 0 &&
      response["non_email_custs"]["Items"][0]["_col0"] !== undefined
    ) {
      non_email_custs = response["non_email_custs"]["Items"][0]["_col0"];
    }

    if (
      response["non_direct_mail"] !== undefined &&
      response["non_direct_mail"]["Items"] !== undefined &&
      response["non_direct_mail"]["Items"].length > 0 &&
      response["non_direct_mail"]["Items"][0]["_col0"] !== undefined
    ) {
      non_direct_mail = response["non_direct_mail"]["Items"][0]["_col0"];
    }
    this.setState({ query_count });
    this.setState({ full_count });
    this.setState({ address_count });
    this.setState({ total_audience_email_count });
    this.setState({ total_audience_email_pre });
    this.setState({ total_audience_email_eclub });
    this.setState({ total_non_mkt });
    this.setState({ total_mkt });
    this.setState({ non_eclub_emails });
    this.setState({ non_preclub_emails });
    this.setState({ non_email_custs });
    this.setState({ non_direct_mail });
    this.setState({ email_count });
    this.setState({ showSummary: false });
    this.setState({
      excludedCount: Math.round(
        (query_count * this.props.cust_sliderValue["sliderValue"]) / 100
      ),
    });
    if (this.props.editMode != undefined) {
      this.props.dispatch({
        type: "CUST_UPDATE_QUERY_COUNT",
        query_count: query_count,
        full_count: full_count,
        address_count: address_count,
        email_count: email_count,
        total_audience_email_count: total_audience_email_count,
        total_audience_email_pre: total_audience_email_pre,
        total_audience_email_eclub: total_audience_email_eclub,
        total_non_mkt: total_non_mkt,
        total_mkt: total_mkt,
        non_eclub_emails: non_eclub_emails,
        non_preclub_emails: non_preclub_emails,
        non_email_custs: non_email_custs,
        non_direct_mail: non_direct_mail,
        preview: [],
      });
    } else {
      this.props.dispatch({
        type: "CUST_CUSTOM_QUERY_COUNT",
        query_count: query_count,
        full_count: full_count,
        address_count: address_count,
        total_audience_email_count: total_audience_email_count,
        total_audience_email_pre: total_audience_email_pre,
        total_audience_email_eclub: total_audience_email_eclub,
        total_non_mkt: total_non_mkt,
        total_mkt: total_mkt,
        non_eclub_emails: non_eclub_emails,
        non_preclub_emails: non_preclub_emails,
        non_email_custs: non_email_custs,
        non_direct_mail: non_direct_mail,
        email_count: email_count,
        preview: [],
      });
    }
    //this.props.dispatch({ type: "SHOW_TABS", payload: "yes" });
    this.props.dispatch({ type: "CUST_Add" });
  }

  prepareIncomeAgeDrivers(backResp) {
    let tempdataLifeDrivers = backResp["life_drivers"];
    this.setState({ tempdataLifeDrivers });
    let tempdataIncome = backResp["income"];
    let tempdataAge = backResp["age"];
    let tempArray = [["Life Driver", "% of Universe", "% of Targeted"]];
    //let tempArray = [['Life Driver', 'IncludedCount', 'ExcludedCount']];
    let universeTotal = 0;
    let targetedTotal = 0;

    for (let key in tempdataLifeDrivers) {
      let lD = tempdataLifeDrivers[key]["targeted"];
      let lD1 = tempdataLifeDrivers[key]["universe"];
      universeTotal = universeTotal + lD1;
      targetedTotal = targetedTotal + lD;
    }

    for (let key in tempdataLifeDrivers) {
      let y = [];
      let lD = tempdataLifeDrivers[key]["targeted"];
      //let upValue = Math.round((lD * this.props.cust_sliderValue['sliderValue'])/100 );
      let lD1 = tempdataLifeDrivers[key]["universe"];
      y.push(key);
      y.push(parseFloat(((lD1 / universeTotal) * 100).toFixed(2)));
      y.push(parseFloat(((lD / targetedTotal) * 100).toFixed(2)));
      tempArray.push(y);
    }
    this.setState({ dataLifeDrivers: tempArray });
    this.setState({ dataLifeDriversDup: tempArray });

    tempArray = [["Income", "INCount"]];
    for (let key in tempdataIncome) {
      let y = [];
      let lD = tempdataIncome[key]["targeted"];
      y.push(key);
      y.push(lD);
      tempArray.push(y);
    }
    this.setState({ dataIncome: tempArray });

    tempArray = [["Age", "AgeCount"]];
    for (let key in tempdataAge) {
      let y = [];
      let lD = tempdataAge[key]["targeted"];
      y.push(key);
      y.push(lD);
      tempArray.push(y);
    }
    this.setState({ dataAge: tempArray });
  }

  apiFetch(where) {
    let whereCondition = "";
    whereCondition = this.getWhereCondition();
    // this.getSegmentsData(whereCondition);
    let condition = whereCondition === "" ? "-" : whereCondition;
    if (
      this.props.cust_summaryDetails["charts_details"]["condition"] === "" ||
      this.props.cust_summaryDetails["charts_details"]["condition"] !==
        condition
    ) {
      this.fetchChartsData(whereCondition);
    } else {
      if (
        this.props.cust_summaryDetails["charts_details"]["value"] !== undefined
      ) {
        this.prepareIncomeAgeDrivers(
          this.props.cust_summaryDetails["charts_details"]["value"]
        );
      } else {
        this.fetchChartsData(whereCondition);
      }
    }
    let fQS =
      "SELECT " +
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("channelsAllObj"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ).filter(
        (obj) =>
          obj.id ===
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("activeChannel"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          )
      )[0]["counts"] +
      " FROM " +
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("custDb"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) +
      ".cust_analytic ca LEFT JOIN " +
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("custDb"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) +
      ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("custDb"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) +
      ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("custDb"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) +
      ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("custDb"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) +
      ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("custDb"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ) +
      ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("globalFilter"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      );
    if (whereCondition.includes("li.")) {
      fQS =
        "SELECT " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("channelsAllObj"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ).filter(
          (obj) =>
            obj.id ===
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("activeChannel"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            )
        )[0]["counts"] +
        " FROM " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".cust_analytic ca LEFT JOIN " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept left join " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ).split("_")[0] +
        "_raw.lists_preclub li on li.cust_id = ca.cust_id WHERE " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("globalFilter"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        );
    }
    if (whereCondition != "") {
      fQS = fQS + " WHERE " + whereCondition;
    }
    if (
      this.props.cust_summaryDetails["query_details"]["condition"] === "" ||
      this.props.cust_summaryDetails["query_details"]["condition"] !== fQS
    ) {
      this.fetchQueryData(fQS);
    } else {
      if (
        this.props.cust_summaryDetails["query_details"]["value"] !== undefined
      ) {
        this.prepareQueryData(
          this.props.cust_summaryDetails["query_details"]["value"]
        );
      } else {
        this.fetchQueryData(fQS);
      }
    }
  }

  numberWithCommas = (x) => {
    if (x != undefined) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      return "";
    }
  };

  // handleChange = (event, value) => {
  //   this.setState({ sliderValue: value });
  //   this.setState({ excludedCount: Math.round((this.state.query_count * value)/100) })
  //   let tempArray = [['Life Driver', 'ActualCount', 'ExcludedCount']];
  //    for (let key in this.state.tempdataLifeDrivers){
  //    let y = []
  //    let upValue = Math.round( (this.state.tempdataLifeDrivers[key] * value)/100 );
  //    y.push(key);
  //    y.push(this.state.tempdataLifeDrivers[key] - upValue);
  //    y.push(upValue);
  //    tempArray.push(y);
  //   }
  //   this.setState({dataLifeDrivers: tempArray});
  //   this.setState({dataLifeDriversDup: tempArray});
  // };
  render() {
    const { classes } = this.props;
    let showSpinner = "";
    let totPopulation = 0;
    let actPopulation = 0;
    // let progressPercentage = 0;
    // if (this.props.queryCount['query_count'] != " ") {
    //   totPopulation = this.props.queryCount['full_count'] != ' ' ? this.props.queryCount['full_count'] : 0;
    //   actPopulation = this.props.queryCount['query_count'] != ' ' ? this.props.queryCount['query_count'] : 0;
    //   progressPercentage = totPopulation !== 0 ? Math.round((actPopulation/totPopulation)*100) : 0;
    // } else {
    //   progressPercentage = 100
    // }
    // if (this.props.showQuerySpinner === "yes") {
    //   showSpinner = (
    //     <i className="fa fa-spinner fa-spin" style={{ fontSize: "24px" }} />
    //   );
    // } else {
    //   showSpinner = this.numberWithCommas(this.props.queryCount['query_count']);
    // }
    let showPage = "";
    if (this.state.showSummary === true) {
      showPage = (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardBody style={{ textAlign: "center" }}>
                <div style={{ textAlign: "center", width: "100%" }}>
                  <i
                    className="fa fa-spinner fa-spin"
                    style={{ fontSize: "50px" }}
                  />
                </div>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      );
    } else {
      showPage = (
        <React.Fragment>
          <GridItem
            xs={8}
            sm={8}
            md={8}
            xl={8}
            style={{ width: "61%", display: "inline-block", float: "right" }}
          >
            <Card style={{}}>
              <CardHeader color="danger" icon>
                <CardIcon color="danger">
                  <Timeline />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Life Drivers</h4>
              </CardHeader>
              <CardBody
                style={{
                  display: "block",
                  transitionDuration: "0.3s",
                  paddingBottom: "60px !important",
                }}
              >
                <Chart
                  width={"100%"}
                  height={"35vh"}
                  chartType="ColumnChart"
                  loader={<div>Loading Chart</div>}
                  data={
                    /*[
                        ['Segments', 'Count', 'Percentages'],
                        ['Seg-1', 8175000, 8008000],
                        ['Seg-2', 3792000, 3694000],
                        ['Remainder', 2695000, 2896000]
                      ]*/
                    this.state.dataLifeDriversDup
                  }
                  options={{
                    //title: 'Population of Largest U.S. Cities',
                    //chartArea: { width: '50%' },
                    //isStacked: true,
                    vAxis: {
                      title: "Total Audience",
                      minValue: 0,
                    },
                    hAxis: {
                      title: "Segments",
                    },
                    colors: [
                      // "#f5801f",
                      "#69ff45",
                      "#808080",
                      "#6691c6",
                      "#b4413e",
                      "#6d833d",
                      "#7e60a0",
                      "#ffff47",
                      "#d30fae",
                      "#3599b8",
                      "#dfbfbf",
                      "#4ac5bb",
                      "#5f6b6d",
                      "#fb8281",
                      "#f4d25a",
                      "#7f898a",
                      "#a4ddee",
                      "#fdab89",
                      "#b687ac",
                      "#28738a",
                      "#a78f8f",
                      "#168980",
                      "#293537",
                      "#bb4a4a",
                      "#b59525",
                      "#475052",
                    ],
                  }}
                  // For tests
                  rootProps={{ "data-testid": "3" }}
                />
              </CardBody>
            </Card>
          </GridItem>
          <GridContainer>
            {/*<GridItem xs={12} sm={12} md={4} xl={4}>
              <Card style={{ height: "60vh"}}>
                  <div className="filtercentercontent summarycontent">
                  <div className="filteraudiencetitle summarytitle">
                    <h2 className="capitalize">Counts</h2>
                  </div>
                <CardBody>
                  <div style={{paddingTop: "20px"}}>
                    <h2 style={{textAlign:"left", float:"left", color:"#417a94"}}>Total Universe  </h2> 
                    <h2 style={{textAlign:"right", float:"right", color:"#417a94", display:"inline"}}><strong> {this.numberWithCommas(this.state.full_count)} </strong></h2> 
                    <br/>
                    <br/>
                    <h2 style={{textAlign:"left", float:"left", color:"#417a94"}}>Targeted Audience  </h2> 
                    <h2 style={{textAlign:"right", float:"right", color:"#417a94", display:"inline"}}><strong> {this.numberWithCommas(this.state.query_count)} </strong></h2> 
                    <br/>
                    <br/>
                    <h2 style={{textAlign:"left", float:"left", color:"#417a94"}}>Targeted with Email  </h2> 
                    <h2 style={{textAlign:"right", float:"right", color:"#417a94", display:"inline"}}><strong> {this.numberWithCommas(this.state.email_count)} </strong></h2> 
                    <br/>
                    <br/>
                    <h2 style={{textAlign:"left", float:"left", color:"#417a94"}}>Targeted with Address  </h2> 
                    <h2 style={{textAlign:"right", float:"right", color:"#417a94", display:"inline"}}><strong> {this.numberWithCommas(this.state.address_count)} </strong></h2> 
                    <br/>
                    <br/>
                    <h2 style={{textAlign:"left", float:"left", color:"#417a94"}}>Segmented  </h2> 
                    <h2 style={{textAlign:"right", float:"right", color:"#417a94", display:"inline"}}><strong> {this.numberWithCommas(this.state.query_count - this.state.remainder) } </strong></h2> 
                    <br/>
                    <br/>
                    <h2 style={{textAlign:"left", float:"left", color:"#417a94"}}>Unsegmented </h2> 
                    <h2 style={{textAlign:"right", float:"right", color:"#417a94", display:"inline"}}><strong> {this.numberWithCommas(this.state.remainder)} </strong></h2> 
                    <br/>
                    </div>
                </CardBody>
                </div>
              </Card>
            </GridItem>*/}
            <GridItem xs={12} sm={12} md={6} xl={6}>
              <Card style={{ height: "60vh" }}>
                <CardHeader color="danger" icon>
                  <CardIcon color="danger">
                    <Timeline />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>Age</h4>
                </CardHeader>
                <CardBody
                  style={{ justifyContent: "center", textAlign: "center" }}
                >
                  <Chart
                    width={"100%"}
                    height={"50vh"}
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={this.state.dataAge}
                    options={{
                      legend: { position: "top", maxLines: 2 },
                      colors: [
                        // "#f5801f",
                        "#69ff45",
                        "#808080",
                        "#6691c6",
                        "#b4413e",
                        "#6d833d",
                        "#7e60a0",
                        "#ffff47",
                        "#d30fae",
                        "#3599b8",
                        "#dfbfbf",
                        "#4ac5bb",
                        "#5f6b6d",
                        "#fb8281",
                        "#f4d25a",
                        "#7f898a",
                        "#a4ddee",
                        "#fdab89",
                        "#b687ac",
                        "#28738a",
                        "#a78f8f",
                        "#168980",
                        "#293537",
                        "#bb4a4a",
                        "#b59525",
                        "#475052",
                      ],
                      chartArea: { width: "95%", height: "80%" },
                      //title: 'Age',
                    }}
                    rootProps={{ "data-testid": "1" }}
                  />
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={6} xl={6}>
              <Card style={{ height: "60vh" }}>
                <CardHeader color="danger" icon>
                  <CardIcon color="danger">
                    <Timeline />
                  </CardIcon>
                  <h4 className={classes.cardIconTitle}>Income</h4>
                </CardHeader>
                <CardBody
                  style={{ justifyContent: "center", textAlign: "center" }}
                >
                  <Chart
                    width={"100%"}
                    height={"50vh"}
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={this.state.dataIncome}
                    options={{
                      legend: { position: "top", maxLines: 4 },
                      colors: [
                        // "#f5801f",
                        "#69ff45",
                        "#808080",
                        "#6691c6",
                        "#b4413e",
                        "#6d833d",
                        "#7e60a0",
                        "#ffff47",
                        "#d30fae",
                        "#3599b8",
                        "#dfbfbf",
                        "#4ac5bb",
                        "#5f6b6d",
                        "#fb8281",
                        "#f4d25a",
                        "#7f898a",
                        "#a4ddee",
                        "#fdab89",
                        "#b687ac",
                        "#28738a",
                        "#a78f8f",
                        "#168980",
                        "#293537",
                        "#bb4a4a",
                        "#b59525",
                        "#475052",
                      ],
                      chartArea: { width: "95%", height: "80%" },
                      //title: 'Age',
                    }}
                    rootProps={{ "data-testid": "1" }}
                  />
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </React.Fragment>
      );
    }
    return <React.Fragment>{showPage}</React.Fragment>;
  }
}
const mapStateToProps = (state) => ({
  cust_count: state.cust_count,
  cust_tillSqlSelectionArr: state.cust_tillSqlSelectionArr,
  cust_afterSqlSelectionArr: state.cust_afterSqlSelectionArr,
  cust_ruleLeveltoggle: state.cust_ruleLeveltoggle,
  cust_groupLeveltoggle: state.cust_groupLeveltoggle,
  title: state.title,
  listDescription: state.listDescription,
  cust_queryCount: state.cust_queryCount,
  cust_showQuerySpinner: state.cust_showQuerySpinner,
  cust_previewData: state.cust_previewData,

  cust_countSegment: state.cust_countSegment,
  cust_tillSqlSelectionArrSegment: state.cust_tillSqlSelectionArrSegment,
  cust_afterSqlSelectionArrSegment: state.cust_afterSqlSelectionArrSegment,
  cust_ruleLeveltoggleSegment: state.cust_ruleLeveltoggleSegment,
  cust_groupLeveltoggleSegment: state.cust_groupLeveltoggleSegment,

  cust_queryCountSegment: state.cust_queryCountSegment,
  cust_showQuerySpinnerSegment: state.cust_showQuerySpinnerSegment,
  cust_previewDataSegment: state.cust_previewDataSegment,
  cust_segmentName: state.cust_segmentName,
  cust_segmentData: state.cust_segmentData,
  cust_hideTabs: state.cust_hideTabs,
  cust_queryCountTempSegment: state.cust_queryCountTempSegment,
  cust_sliderValue: state.cust_sliderValue,
  cust_summaryDetails: state.cust_summaryDetails,
});

export default connect(mapStateToProps)(withStyles(chartsStyle)(Summary));



// WEBPACK FOOTER //
// ./src/views/Audiences/CustomerSummary.jsx